document.addEventListener("DOMContentLoaded", function () {
    const clickEffect = document.querySelector(".click-effect");
    if (clickEffect) {
        document.addEventListener("click", function (event) {
            clickEffect.classList.add("active");
            clickEffect.style.top = `${event.clientY}px`;
            clickEffect.style.left = `${event.clientX}px`;
            setTimeout(() => {
                clickEffect.classList.remove("active");
            }, 400);
        });
    }
});